import React from 'react'
import { Badge, Box, Text } from '@chakra-ui/react'

import {
    ClientNoteFieldsFragment,
    PatientNoteFieldsFragment,
} from '~graphql/generated/graphql'
import { useFormatDate } from '~utils/hooks/use-format-date'
import { DateFormat } from '~utils/shared-types'

interface Props {
    note: ClientNoteFieldsFragment | PatientNoteFieldsFragment
}

function isInternalNote(
    note: ClientNoteFieldsFragment | PatientNoteFieldsFragment,
): boolean {
    return 'is_internal' in note && note.is_internal === true
}

export default function ChatClientDetailsNoteItem({ note }: Props) {
    const { formatDate } = useFormatDate()

    if (!note.text) return null

    return (
        <Box
            p={2}
            rounded="xl"
            bg="gray.50"
            borderWidth={1}
            borderColor="gray.100"
        >
            <Text fontSize="xs" color="gray.900" whiteSpace="pre-wrap">
                {note.text}
            </Text>
            <Box mt={1} display="flex" alignItems="center" gap={2}>
                <Text fontSize="11px" color="gray.500">
                    {formatDate(
                        note.noted_at ?? note.created_at,
                        DateFormat.Date,
                    )}
                </Text>
                {isInternalNote(note) && (
                    <Badge
                        fontSize="9px"
                        colorScheme="orange"
                        variant="subtle"
                    >
                        Internal
                    </Badge>
                )}
            </Box>
        </Box>
    )
}
